import { REQUEST, SUCCESS, FAILURE } from '../../actions/constants'
import { actionCreator, createRequestTypes } from '../../actions'

// TO LOAD PRICE HISTORY FOR PRINT LISTING PAGE ////////////////////////////
export const LOAD_PRINT_ARCHIVE_LISTINGS = 'LOAD_PRINT_ARCHIVE_LISTINGS'
export const loadPrintArchiveListings = payload =>
  actionCreator(LOAD_PRINT_ARCHIVE_LISTINGS, { payload })


export const LOAD_PRINT_ARCHIVE_LISTINGS_DATA = createRequestTypes('LOAD_PRINT_ARCHIVE_LISTINGS_DATA')
export const getPrintArchiveListingsAction = {
  request: params => actionCreator(LOAD_PRINT_ARCHIVE_LISTINGS_DATA[REQUEST], { params }),
  success: (defaults, response) => actionCreator(LOAD_PRINT_ARCHIVE_LISTINGS_DATA[SUCCESS], { response }),
  failure: (defaults, error) => actionCreator(LOAD_PRINT_ARCHIVE_LISTINGS_DATA[FAILURE], { error }),
}
